import { ProductType, PriceType } from "@wix/ambassador-forms-v4-form/types";
import { generateUUID } from "@wix/form-schema";
function toProductValue(product, value) {
  return {
    productId: product.id,
    price: value,
    quantity: 1
  };
}
function aDynamicPricePayment(id = generateUUID(), min = 1, max) {
  return {
    id,
    priceType: PriceType.DYNAMIC_PRICE,
    productType: ProductType.DIGITAL,
    quantityLimit: { minimum: 1, maximum: 1 },
    dynamicPriceOptions: {
      minPrice: String(min),
      maxPrice: max ? String(max) : void 0
    }
  };
}
export {
  aDynamicPricePayment,
  toProductValue
};
//# sourceMappingURL=payment-input-field-utils.js.map
